import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../store';
import CollapsibleSwitchListItem from '../../../../../list-items/CollapsibleSwitchListItem';
import BackdropVideoAccelerationIntensitySlider from './BackdropVideoAccelerationIntensitySlider';
import { MEDIA_RESOURCE_TYPE } from '../../../CreatePageConstants';

const PERFORMANCE_WARNING = "Your device can't keep up with dynamic playback at this resolution. The effect has been disabled for the preview, but will still be applied on export. Try lowering the preview quality.";
const OPTIMIZATION_MODE_WARNING = "Preview for this feature is disabled in Optimization Mode to save resources. It will be applied normally on the final export.";

const BackdropVideoAccelerationListItem = (props) => {
    const { videoAccelerationEnabled, updateBackgroundSettings, canEnable, videoAccelerationUnsupported, optimizationModeEnabled, isVideo } = props;

    // Only relevant for video backgrounds — hidden entirely otherwise.
    if (!isVideo)
        return null;

    // In Optimization Mode the preview skips WebCodecs entirely, so the warning shows the
    // moment the effect is switched on rather than waiting for a performance check to fail.
    const warning = videoAccelerationEnabled
        ? (optimizationModeEnabled && OPTIMIZATION_MODE_WARNING) || (videoAccelerationUnsupported && PERFORMANCE_WARNING) || undefined
        : undefined;

    return (
        <CollapsibleSwitchListItem
            text='Background Video Speed Up'
            checked={videoAccelerationEnabled}
            onChange={(value) => updateBackgroundSettings({ videoAcceleration: { enabled: value } })}
            toolTip='Background video will speed up during loud audio when this is enabled.'
            warning={warning}
            disabled={!canEnable}
        >
            <List dense disablePadding>
                <BackdropVideoAccelerationIntensitySlider />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const { videoAcceleration, mediaSource } = state.createPreview.present.videoSettings.background;
    const { backgroundVideoDuration, videoAccelerationUnsupported, optimizationModeEnabled } = state.create;
    const isVideo = mediaSource && mediaSource.mediaResourceType === MEDIA_RESOURCE_TYPE.VIDEO;
    const canEnable = isVideo && backgroundVideoDuration > 0;

    return {
        isVideo: isVideo || false,
        videoAccelerationEnabled: videoAcceleration?.enabled || false,
        canEnable: canEnable || false,
        videoAccelerationUnsupported: videoAccelerationUnsupported || false,
        optimizationModeEnabled: optimizationModeEnabled || false
    }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropVideoAccelerationListItem);
